import React from 'react';
import {Typography} from '@material-ui/core';
import moment from 'moment';

import Card from 'components/controls/Card';
import CustomBox from 'components/controls/grid/CustomBox';
import CustomGrid from 'components/controls/grid/CustomGrid';
import Avatar from 'components/controls/Avatar';
import StarsBar from 'components/controls/StarsBar';
import RichTextView from 'components/controls/RichTextView';

export default function DoctorReview({review, className}) {
    const {patient = {}} = review;

    return (
        <Card classes={{root: className}}>
            <CustomBox
                px="xl"
                py="xxl"
            >
                <CustomGrid
                    container
                    spacing="m"
                >
                    <CustomGrid
                        item
                        xs={12}
                        container
                        justify="space-between"
                    >
                        <CustomGrid
                            item
                            container
                            spacing="s"
                            xs={9}
                        >
                            <CustomGrid
                                item
                                xs={3}
                            >
                                <Avatar
                                    size="small"
                                    src={patient && patient.avatar}
                                />
                            </CustomGrid>
                            <CustomGrid
                                item
                                container
                                xs={9}
                                direction="column"
                                justify="space-between"
                            >
                                <Typography
                                    variant="body1"
                                >
                                    {patient && patient.fullName}
                                </Typography>
                                <Typography
                                    variant="body2"
                                >
                                    {review.createdAt ? moment(review.createdAt).format('DD MMM YYYY [  ·  ]HH:mm') : review.title}
                                </Typography>
                            </CustomGrid>
                        </CustomGrid>

                        <CustomGrid
                            item
                            xs={3}
                        >
                            <StarsBar
                                value={review.rating}
                            />
                        </CustomGrid>
                    </CustomGrid>
                    <CustomGrid
                        item
                        xs={12}
                    >
                        <RichTextView>
                            {review.review}
                        </RichTextView>
                    </CustomGrid>
                </CustomGrid>
            </CustomBox>
        </Card>
    );
}



// WEBPACK FOOTER //
// ./src/components/Doctors/DoctorReviews/DoctorReview.jsx